<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">

                <el-table :data="businessData" border>
                    <el-table-column prop="id" label="编号" width="60px">
                    </el-table-column>
                    <el-table-column prop="key_description" label="描述">
                    </el-table-column>
                    <el-table-column prop="key_value" label="参数">
                    </el-table-column>
                    <el-table-column label="操作" width="60px">
                        <template slot-scope="scope">
                            <el-button type="text" @click="showModifyBusiness(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-dialog
                    title="编辑"
                    :visible.sync="modifyBusinessShow"
                    width="35%" lock-scroll
                    center>
                    <el-form label-width="60px" label-suffix=":" label-position="left">
                        <el-form-item label="参数" v-if="businessBO.id == '101'">
                            <el-button type="primary" @click="addConfigValueItem">添加</el-button>
                            <div v-for="(item,index) in configValue" style="display:flex;margin: 10px 0;">
                                <el-input v-model="configValue[index]"></el-input>
                                <el-button type="primary" icon="el-icon-delete" @click="delConfigValueItem(index)" style="margin-left: 5px;"></el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="参数" v-if=" businessBO.id == '103'">
                            <el-input-number v-model="businessBO.configValue" :precision="0" :max="2" :min="0"></el-input-number>
                        </el-form-item>
                        <el-form-item label="参数" v-if="businessBO.id == '201' || businessBO.id == '102' || businessBO.id == '202' || businessBO.id == '301'|| businessBO.id == '401'|| businessBO.id == '402'">
                            <el-input v-model="businessBO.configValue"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="modifyBusinessShow = false">取消</el-button>
                        <el-button type="primary" @click="modifyBusinessConfiguration">确认</el-button>
                    </div>
                </el-dialog>
            </section>
        </div>
    </el-card>
</template>

<script>
    import {mapState} from 'vuex';
    import confApi from '../../service/conf_api'
    import gameApi from '../../service/game_api'
    import beastsApi from "../../service/beasts_api";

    export default {
        name: "game_business",
        data () {
            return {
                businessData: [],
                modifyBusinessShow: false,
                businessBO: {
                    id:'',
                    configValue:''
                },
                configValue: []
            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverWorldList: state => state.server.serverWorldList,
                serverGameList: state => state.server.serverGameList,
            }),
        },
        mounted() {
          this.getBusinessData();
        },
        methods: {
            // 获取业务参数数据
            getBusinessData() {
                var self = this;
                confApi.getReadData({
                    token: self.token,
                    tableName: 'business_configuration'
                }).then(res => {
                    self.businessData = res;
                })
            },

            showModifyBusiness(e) {
                this.modifyBusinessShow = true;
                this.businessBO = {
                    id: e.id,
                    configValue: e.key_value
                }
                if (e.id == '101') {
                    this.configValue = JSON.parse(e.key_value);
                }
            },

            addConfigValueItem() {
                this.configValue.push([]);
            },

            delConfigValueItem(index) {
                this.configValue.splice(index,1);
            },

            // 修改业务参数
            modifyBusinessConfiguration() {
                if (this.businessBO.id == '101') {
                    this.businessBO.configValue = JSON.stringify(this.configValue);
                }
                confApi.modifyBusinessConfiguration({
                    token: this.token,
                    businessBO: this.businessBO
                }).then(res => {
                    this.modifyBusinessShow = false;
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    })
                    //this.reloadAxiosALLGame();
                    this.reloadAxiosALLGame2();
                    this.getBusinessData();
                })
            },
            reloadAxiosALLGame2(){
                beastsApi.reloadClzName({
                    token: this.token,
                    reloadForm: {
                        reloadTypes: ['wholeGame'],
                        gameNumbers: [],
                        worldNumbers: [],
                        reloadMode: '1',
                        clzName: 'BusinessConfiguration'
                    }
                }).then(res => {})
            },

            // 重载全部游戏服
            reloadAxiosALLGame() {
                let self = this;
                var reloadConfigData = [];

                self.serverGameList.forEach(serverGameItem => {
                    reloadConfigData.push({
                        uri: serverGameItem.inner_urls.split(';')[0],
                        type: 'game',
                    })

                    var balanceIps = serverGameItem.inner_urls.split(';');
                    balanceIps.shift();
                    if (balanceIps !== null && balanceIps[0] !== '' && balanceIps.length > 0) {
                        balanceIps.forEach(balanceIpsItem => {
                            reloadConfigData.push({
                                uri: balanceIpsItem,
                                type: 'game',
                            })
                        });
                    }
                })

                reloadConfigData.forEach(reloadItem => {
                    let reloadForm = {};
                    if (reloadItem.type == 'game') {
                        reloadForm = {
                            uri: reloadItem.uri,
                            type: reloadItem.type,
                            className: 'BusinessConfiguration'
                        }
                    }
                    gameApi.gameReloadConfig({
                        token: self.token,
                        reloadForm: reloadForm
                    }).then(res => {

                    })
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/maintenance/game_business.vue